/**
 * @generated SignedSource<<aee4d632d08e3f91f0b91b1450b78035>>
 * @relayHash 3681b7ed328fbc24d7c85e9a38792f1e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c7d208559ac8563e6f5acd98cc24a4f3985b7efb2b89c69336bd060de1c4967a

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type CustomerServiceReportedByFilter = "OTHER" | "SHARED_BY_ORG" | "USER" | "%future added value";
export type CustomerServiceStatusKey = "RESOLVED" | "SUBMITTED" | "%future added value";
export type CustomerServiceRequestFilterInput = {
  reportedBy?: CustomerServiceReportedByFilter | null;
  searchText?: string | null;
  status?: CustomerServiceStatusKey | null;
  statusFilter?: ReadonlyArray<string> | null;
};
export type csmRequestsListQuery$variables = {
  accountId: string;
  cloudId: string;
  count?: number | null;
  filter?: CustomerServiceRequestFilterInput | null;
  helpCenterId: string;
};
export type csmRequestsListQuery$data = {
  readonly customerService: {
    readonly externalStatusesByHelpCenterId: {
      readonly externalStatuses?: ReadonlyArray<{
        readonly externalLabel: string;
        readonly jiraStatusIds: ReadonlyArray<string>;
        readonly statusCategory: string | null;
      }>;
      readonly identifier?: string | null;
      readonly message?: string | null;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"requestsTable_csmRequestsList">;
};
export type csmRequestsListQuery = {
  response: csmRequestsListQuery$data;
  variables: csmRequestsListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterId"
},
v5 = {
  "kind": "Variable",
  "name": "accountId",
  "variableName": "accountId"
},
v6 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v7 = {
  "kind": "Variable",
  "name": "filter",
  "variableName": "filter"
},
v8 = {
  "kind": "Variable",
  "name": "helpCenterId",
  "variableName": "helpCenterId"
},
v9 = [
  (v6/*: any*/)
],
v10 = [
  (v8/*: any*/)
],
v11 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "CustomerServiceExternalStatus",
      "kind": "LinkedField",
      "name": "externalStatuses",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "externalLabel"
        },
        {
          "kind": "ScalarField",
          "name": "jiraStatusIds"
        },
        {
          "kind": "ScalarField",
          "name": "statusCategory"
        }
      ]
    }
  ],
  "type": "CustomerServiceExternalStatusesResponse"
},
v12 = {
  "kind": "ScalarField",
  "name": "identifier"
},
v13 = {
  "kind": "ScalarField",
  "name": "message"
},
v14 = {
  "kind": "InlineFragment",
  "selections": [
    (v12/*: any*/),
    (v13/*: any*/)
  ],
  "type": "QueryError"
},
v15 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v16 = [
  (v7/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v8/*: any*/)
],
v17 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "csmRequestsListQuery",
    "selections": [
      {
        "args": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "requestsTable_csmRequestsList"
      },
      {
        "args": (v9/*: any*/),
        "concreteType": "CustomerServiceQueryApi",
        "kind": "LinkedField",
        "name": "customerService",
        "plural": false,
        "selections": [
          {
            "args": (v10/*: any*/),
            "kind": "LinkedField",
            "name": "externalStatusesByHelpCenterId",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v14/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "csmRequestsListQuery",
    "selections": [
      {
        "args": (v9/*: any*/),
        "concreteType": "CustomerServiceQueryApi",
        "kind": "LinkedField",
        "name": "customerService",
        "plural": false,
        "selections": [
          {
            "args": [
              (v5/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "individualByAccountId",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v16/*: any*/),
                    "concreteType": "CustomerServiceRequestConnection",
                    "kind": "LinkedField",
                    "name": "requests",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "CustomerServiceRequestEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "CustomerServiceRequest",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "key"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "summary"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "statusKey"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "externalStatus"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "statusCategoryName"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "reporterDisplayName"
                              },
                              {
                                "concreteType": "CustomerServiceRequestSharedOrganization",
                                "kind": "LinkedField",
                                "name": "sharedOrganizations",
                                "plural": true,
                                "selections": [
                                  (v17/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "name"
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "createdOn"
                              },
                              (v17/*: any*/),
                              (v15/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "cursor"
                          }
                        ]
                      },
                      {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "endCursor"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "args": (v16/*: any*/),
                    "filters": [
                      "helpCenterId",
                      "filter"
                    ],
                    "handle": "connection",
                    "key": "requestsTable_requests",
                    "kind": "LinkedHandle",
                    "name": "requests"
                  }
                ],
                "type": "CustomerServiceIndividual"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v12/*: any*/),
                  (v13/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "statusCode"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "errorType"
                      }
                    ]
                  }
                ],
                "type": "QueryError"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v17/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          },
          {
            "args": (v10/*: any*/),
            "kind": "LinkedField",
            "name": "externalStatusesByHelpCenterId",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              (v11/*: any*/),
              (v14/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c7d208559ac8563e6f5acd98cc24a4f3985b7efb2b89c69336bd060de1c4967a",
    "metadata": {},
    "name": "csmRequestsListQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "cb6332bdb26c3936c3393e7e0eb0eafc";

export default node;
